@if (loaderIcon | async) {
<app-loader></app-loader>
}
<div class="layout-container">
    <app-operations [isCollapsed]="isCollapsed"></app-operations>

    <div class="main-content">
        <app-top-bar (toggleSidebar)="handleToggle()"></app-top-bar>
        <form [formGroup]="DeleteRentalForm">
            <div class="content-area">
                <div class="d-flex justify-content-between align-items-center mb-3">
                    <h5 class="fw-semibold">Delete Rental</h5>
                </div>
                <hr />
                <div class="form-container">
                    <div class="row">

                        <div class="col-md-6 col-lg-4 text-start" *ngIf="daily">
                            <label>
                                <input class="form-check-input" type="radio" value="1" formControlName="rentalType"
                                    (change)="loadVendorDetails()" />
                                &nbsp;Daily
                            </label>
                        </div>

                        <div class="col-md-6 col-lg-4 text-start" *ngIf="combinedWeekly">
                            <label>
                                <input class="form-check-input" type="radio" value="5" formControlName="rentalType"
                                    (change)="loadVendorDetails()" />
                                &nbsp;Weekly
                            </label>
                        </div>

                        <div class="col-md-6 col-lg-4 text-start" *ngIf="combinedMonthly">
                            <label>
                                <input class="form-check-input" type="radio" value="4" formControlName="rentalType"
                                    (change)="loadVendorDetails()" />
                                &nbsp;Monthly
                            </label>
                        </div>

                    </div>

                </div>
                <div class="row my-2 align-items-center">
                    <div class="col-auto">
                        <label>
                            <input type="radio" value="1" formControlName="searchOption" class="form-check-input"
                                (click)="onSearchOptionBlur()">
                            &nbsp; {{ 'Vendor ID' | wordReplace }}
                        </label>
                    </div>

                    <div class="col col-lg-3">
                        <input type="text" class="form-control" formControlName="chkVendorIdValue"
                            (blur)="getVendorById()" [readonly]="DeleteRentalForm.get('searchOption')?.value === '2'" />
                    </div>

                    <div class="col col-lg-3">
                        <input type="text" class="form-control" formControlName="chkVendorName" readonly />
                    </div>

                    <div class="col-auto">
                        <button type="button" class="btn btn-sm btn-dark" (click)="openVendorSearch()"
                            [disabled]="DeleteRentalForm.get('searchOption')?.value === '2'">
                            <img src="./assets/images/search.svg" class="img-fluid" />
                        </button>
                    </div>
                </div>

                <div class="row mb-2 align-items-center">
                    <div class="col-auto">
                        <label>
                            <input type="radio" value="2" formControlName="searchOption" class="form-check-input"
                                (click)="onSearchOptionBlur()">
                            &nbsp; {{ 'Booth Number' | wordReplace }}
                        </label>
                    </div>
                    <div class="col">
                        <input type="text" class="form-control" formControlName="txtBooth"
                            (keydown.enter)="onBoothSearch()"
                            [readonly]="DeleteRentalForm.get('searchOption')?.value === '1'" />
                    </div>
                    <div class="col-auto">
                        <button type="button" class="btn btn-dark" (click)="onBoothSearch()"
                            [disabled]="DeleteRentalForm.get('searchOption')?.value === '1'">
                            <img src="./assets/images/search.svg" class="img-fluid" />
                        </button>
                    </div>
                    <div class="col text-end">
                        <label for="transactionDate" class="form-label">Transaction Date</label>
                    </div>
                    <div class="col-md-6 col-lg-2">
                        <ejs-datepicker formControlName="TransactionDate" id="transactionDate"
                            [readonly]="true"></ejs-datepicker>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-6">
                        <label for="vendorComments" class="form-label"> {{ 'Vendor Comments' | wordReplace }}</label>
                        <div class="input-group">
                            <input type="text" class="form-control" formControlName="VendorComments"
                                id="vendorComments" />
                            <button class="btn btn-dark ms-4" type="button" style="border-radius: 6px;"
                                data-bs-toggle="modal" data-bs-target="#staticBackdrop">...</button>
                        </div>
                    </div>
                    <div class="col-6">
                        <label for="RentalNotes" class="form-label">Rental Notes</label>
                        <div class="input-group">
                            <input type="text" class="form-control" id="RentalNotes" formControlName="rentalNotes"
                                readonly />
                            <button class="btn btn-dark ms-4" type="button" style="border-radius: 6px;"
                                data-bs-toggle="modal" data-bs-target="#modalRentalNotes"
                                (click)="loadDefaultRentalNotes()">...</button>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 col-lg-9 text-start">
                        <ul class="nav nav-tabs custom-tabs">
                            <li class="nav-item">
                                <a class="nav-link active" data-bs-toggle="tab" href="#bookings">Bookings</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" data-bs-toggle="tab" href="#otherCharges">Other Charges</a>
                            </li>
                        </ul>
                        <div class="tab-content">
                            <div class="tab-pane fade show active" id="bookings">
                                <div class="mt-2">
                                    <div class="tab-content border border-top-0 p-3">
                                        <div class="tab-pane fade show active" id="daily">
                                            <div class="row">
                                                <div class="col-md-12 text-start mt-2">
                                                    <div class="mb-2">
                                                        <div
                                                            class="d-flex justify-content-between align-items-center mb-2">
                                                            <h6 class="fw-bold"> {{ 'Booth Rentals' | wordReplace }}
                                                            </h6>
                                                            <button type="button" class="btn btn-danger btn-sm"
                                                                (click)="moveToDeletedBookings()">
                                                                <img src="./assets/images/delete-white.svg"
                                                                    class="img-fluid" />
                                                            </button>
                                                        </div>

                                                        <ejs-grid #Bookingsgrid [dataSource]="selectedBookingBooths"
                                                            [allowPaging]="false" [height]="230">
                                                            <e-columns>
                                                                <e-column field='BoothNumber'
                                                                    headerText="{{ 'Booth #' | wordReplace }}"
                                                                    textAlign='left' width=120>
                                                                </e-column>
                                                                @if(noLayout == false){
                                                                    <e-column field='BoothType'
                                                                    headerText="{{ 'Booth Type' | wordReplace }}"
                                                                    textAlign='left' width=110>
                                                                </e-column>
                                                                }
                                                                <e-column field='Product' headerText='Product'
                                                                    width=200>
                                                                    <ng-template #template let-data>
                                                                        <span class="dataName">
                                                                            <select class="form-control"
                                                                                [(ngModel)]="data.Product"
                                                                                [ngModelOptions]="{standalone: true}">
                                                                                <option
                                                                                    *ngFor="let item of vendorProducts"
                                                                                    [value]="item.ProductId">
                                                                                    {{item.ProductName}}</option>
                                                                            </select></span>
                                                                    </ng-template>
                                                                </e-column>
                                                                <e-column field='RentalStartDate'
                                                                    headerText='Rental Start Date' width=160>
                                                                </e-column>
                                                                <e-column field='RentalEndDate'
                                                                    headerText='Rental End Date' width=150>
                                                                </e-column>
                                                                <e-column field='RentalYearMonth'
                                                                    headerText='Rental Period' width=150>
                                                                </e-column>
                                                                <e-column field='Rent' headerText='Rent'
                                                                    textAlign="Right" width=120>
                                                                </e-column>
                                                            </e-columns>
                                                        </ejs-grid>
                                                    </div>
                                                    <div>
                                                        <div
                                                            class="d-flex justify-content-between align-items-center mb-2">
                                                            <h6 class="fw-bold">Delete Rentals</h6>
                                                            <button type="button" class="btn btn-danger btn-sm"
                                                                (click)="revertDeletedBookings()">
                                                                <img src="./assets/images/delete-white.svg"
                                                                    class="img-fluid" />
                                                            </button>
                                                        </div>

                                                        <ejs-grid #gridDeleteBooking
                                                            class="Table_Height_store table-striped table-ipad"
                                                            allowSelection="false" [height]="230"
                                                            [dataSource]="DeleteBooking">
                                                            <e-columns>
                                                                <e-column field="MakeAvail" headerText="Make Avail"
                                                                    width="110" textAlign="Center">
                                                                    <ng-template #template let-data>
                                                                        <input type="checkbox" class="form-check-input"
                                                                            [(ngModel)]="data.MakeAvail"
                                                                            [ngModelOptions]="{standalone: true}"
                                                                            [disabled]="!data.DelBooking"
                                                                            (change)="applyMakeAvailForRow(data)">
                                                                    </ng-template>
                                                                </e-column>
                                                                <e-column field="DelBooking" headerText="Del Booking"
                                                                    width="120" textAlign="Center">
                                                                    <ng-template #template let-data>
                                                                        <input type="checkbox" class="form-check-input"
                                                                            [(ngModel)]="data.DelBooking"
                                                                            [ngModelOptions]="{standalone: true}"
                                                                            (change)="applyDelBookingForRow(data)">
                                                                    </ng-template>
                                                                </e-column>
                                                                <e-column field='BoothNumber'
                                                                    headerText="{{ 'Booth #' | wordReplace }}"
                                                                    textAlign='left' width=120>
                                                                </e-column>
                                                                <e-column field='RentalStartDate'
                                                                    headerText='Rental Start Date' width=160>
                                                                </e-column>
                                                                <e-column field='RentalEndDate'
                                                                    headerText='Rental End Date' width=220>
                                                                    <ng-template #template let-data>
                                                                        <select class="form-control form-select"
                                                                            [(ngModel)]="data.UpdatedRentalEndDate"
                                                                            [ngModelOptions]="{standalone: true}"
                                                                            [disabled]="data.DelBooking"
                                                                            (change)="onRentalEndDateChange(data)">
                                                                            <option
                                                                                *ngFor="let item of data.AvailableEndDates"
                                                                                [ngValue]="item">
                                                                                {{ item }}
                                                                            </option>
                                                                        </select>
                                                                    </ng-template>
                                                                </e-column>
                                                                <e-column field='RentalYearMonth'
                                                                    headerText='Rental Period' width=150>
                                                                </e-column>
                                                                <e-column field='Rent' headerText='Rent Amt'
                                                                    textAlign="Right" width=120>
                                                                </e-column>
                                                                <e-column field='RentRefund' headerText='Refund Amt'
                                                                    width=130>
                                                                    <ng-template #template let-data>
                                                                        <span class="dataName">
                                                                            <input type="text"
                                                                                class="form-control text-right pr-1"
                                                                                style="color: blue !important;"
                                                                                [(ngModel)]="data.RentRefund"
                                                                                [ngModelOptions]="{standalone: true}"
                                                                                [readonly]="data.ZeroOut"
                                                                                (blur)="updateRefund(data)"
                                                                                (keypress)="numberOnly($event)"
                                                                                (click)="$event.stopPropagation()"
                                                                                appRemoveCurrencyFormatting>
                                                                        </span>
                                                                    </ng-template>
                                                                </e-column>
                                                                @if(noLayout == false){
                                                                <e-column field='BoothType'
                                                                    headerText="{{ 'Booth Type' | wordReplace }}"
                                                                    textAlign='left' width=110>
                                                                </e-column>
                                                                }
                                                                <e-column field='Product' headerText='Product'
                                                                    width=200>
                                                                    <ng-template #template let-data>
                                                                        <span class="dataName">
                                                                            <select class="form-control"
                                                                                [(ngModel)]="data.Product"
                                                                                [ngModelOptions]="{standalone: true}">
                                                                                <option
                                                                                    *ngFor="let item of vendorProducts"
                                                                                    [value]="item.ProductId">
                                                                                    {{item.ProductName}}</option>
                                                                            </select></span>
                                                                    </ng-template>
                                                                </e-column>
                                                                <e-column field="ZeroOut" headerText="Zero Out"
                                                                    width="110" textAlign="Center">
                                                                    <ng-template #template let-data>
                                                                        <input type="checkbox" class="form-check-input"
                                                                            [(ngModel)]="data.ZeroOut"
                                                                            [ngModelOptions]="{standalone: true}"
                                                                            (ngModelChange)="applyZeroOutForRow(data)"
                                                                            (click)="$event.stopPropagation()">
                                                                    </ng-template>
                                                                </e-column>
                                                            </e-columns>
                                                        </ejs-grid>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade" id="otherCharges">
                                <div class="p-3">
                                    <div class="mt-2">
                                        <div class="row">
                                            <div class="col-md-12 text-start mt-2">
                                                <div class="mb-2">
                                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                                        <h6 class="fw-bold">Other Charges</h6>
                                                    </div>
                                                    <ejs-grid #gridOtherItems [dataSource]="selectedOtherItems"
                                                        [height]="230">
                                                        <e-columns>
                                                            <e-column field="item" headerText="Item"
                                                                width="120"></e-column>
                                                            <e-column field="rec" headerText="Rec" width="80"
                                                                textAlign="Center">
                                                                <ng-template #template let-data>
                                                                    <i class="bi bi-check-square-fill checkBoxClass"
                                                                        *ngIf="data.rec"></i>
                                                                    <i class="bi bi-square checkBoxClass"
                                                                        *ngIf="!data.rec"></i>
                                                                </ng-template>
                                                            </e-column>
                                                            <e-column field="unitCharge" headerText="Unit Price"
                                                                width="120" textAlign="Right"></e-column>
                                                            <e-column field="qty" headerText="Qty" width="80"
                                                                textAlign="Center"></e-column>
                                                            <e-column field="reference" headerText="Reference"
                                                                width="140"></e-column>
                                                            <e-column field="rentalPeriod" headerText="Rental Period"
                                                                width="140" textAlign="Left"></e-column>
                                                            <e-column headerText="Refund Unit Price" width="170"
                                                                textAlign="Right">
                                                                <ng-template #template let-data>
                                                                    {{ getRentalUnitCharge(data) }}
                                                                </ng-template>
                                                            </e-column>
                                                            <e-column field="qtyToDelete" headerText="Qty To Delete"
                                                                width="130" textAlign="Right">
                                                                <ng-template #template let-data>
                                                                    <span class="dataName">
                                                                        <input type="number"
                                                                            class="form-control text-right pr-1"
                                                                            style="color: blue !important;" min="0"
                                                                            [max]="data.qty" [value]="data.qtyToDelete"
                                                                            (keypress)="numberOnly($event)"
                                                                            (blur)="updateotheritemlist(data, $event); CalculateDue()"
                                                                            (input)="onQtyToDeleteChange(data, $event)" />
                                                                    </span>
                                                                </ng-template>
                                                            </e-column>
                                                        </e-columns>
                                                    </ejs-grid>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                    <div class="col-md-12 col-lg-3 text-start mt-3">
                        <div class="mt-2">
                            <div class="border rounded p-3" style="max-width: 500px;"
                                formGroupName="ReceiptAndContractSetting">
                                <div class="row mb-2">
                                    <div class="col-6">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" id="printReceipt"
                                                formControlName="printReceipt">
                                            <label class="form-check-label" for="printReceipt">Print Receipt</label>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-6">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" id="DisplayReceipt"
                                                formControlName="displayReceipt">
                                            <label class="form-check-label" for="DisplayReceipt">Display Receipt</label>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" id="emailReceipt"
                                                formControlName="emailReceipt">
                                            <label class="form-check-label" for="emailReceipt">Email Receipt</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Refund Charges -->
                        <div class="mt-2">
                            <div class="border rounded p-3" formGroupName="refundCharges">
                                <h6 class="fw-bold">Refund Charges</h6>

                                <div class="row mb-3">
                                    <div class="col-6">
                                        <label for="rentRefund" class="form-label">Rent
                                            Refund</label>
                                        <input type="text" class="form-control text-end" id="rentRefund"
                                            formControlName="rentRefund" readonly>
                                    </div>
                                    <div class="col-6">
                                        <label for="otherChargesRefund" class="form-label">Other Charges Refund</label>
                                        <input type="text" class="form-control text-end" id="otherChargesRefund"
                                            formControlName="otherChargesRefund" readonly>
                                    </div>
                                </div>

                                <div class="row mb-3">
                                    <div class="col-6">
                                        <label for="salesTaxRefund" class="form-label">Sales
                                            Tax Refund</label>
                                        <input type="text" class="form-control text-end" id="salesTaxRefund"
                                            formControlName="salesTaxRefund" readonly>
                                    </div>
                                    <div class="col-6">
                                        <label for="secLevelTaxRefund" class="form-label">Second Level Tax
                                            Refund</label>
                                        <input type="text" class="form-control text-end" id="secLevelTaxRefund"
                                            formControlName="secLevelTaxRefund" readonly>
                                    </div>
                                </div>

                                <div class="row mb-3">
                                    <div class="col-6">
                                        <label for="discountRefund" class="form-label">Discount Refund</label>
                                        <input type="text" class="form-control text-end" id="discountRefund"
                                            formControlName="discountRefund" readonly>
                                    </div>
                                    <div class="col-6">
                                        <label for="priorArBalance" class="form-label">Prior
                                            AR Balance</label>
                                        <input type="text" class="form-control text-end" id="priorArBalance"
                                            formControlName="priorArBalance" readonly>
                                    </div>
                                </div>

                                <div class="mb-2">
                                    <label for="totalRefundAmt" class="form-label fw-bold">Total Refund Amt</label>
                                    <input type="text" class="form-control text-end" id="totalRefundAmt"
                                        formControlName="totalRefundAmt" readonly>
                                </div>
                            </div>
                        </div>

                        @if(canDisplaySaveAndRefund){
                        <div class="form-check mt-2 mb-2">
                            <input type="checkbox" class="form-check-input" id="chkRefundMode"
                                formControlName="isRefundMode" (change)="onRefundModeChanged()" />

                            <label class="form-check-label" for="chkRefundMode">
                                Process Refund (Cash)
                            </label>
                        </div>
                        }

                        <!-- Other Refund Charges -->
                        <div class="mt-3">
                            <div class="border rounded p-3" formGroupName="otherRefundCharges">
                                <h6 class="fw-bold">Refund Details</h6>
                                <div class="row mb-3">
                                    <div class="col-6">
                                        <label for="cashRefund" class="form-label">Cash
                                            Refund</label>
                                        <input type="text" class="form-control text-end" id="cashRefund"
                                            formControlName="cashRefund" readonly>
                                    </div>
                                    <div class="col-6">
                                        <label for="ccRefund" class="form-label">CC Amount
                                            Refund</label>
                                        <input type="text" class="form-control text-end" id="ccRefund"
                                            formControlName="ccRefund" readonly>
                                    </div>
                                </div>
                                <div>
                                    <label for="balanceDue" class="form-label fw-bold">Vendor Balance</label>
                                    <input type="text" class="form-control text-end" id="balanceDue"
                                        formControlName="balanceDue" readonly>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 text-end my-3">
                        <div class="row">
                            <div class="col-12 text-md-end my-3">
                                <button class="btn btnAS ms-1" type="button" (click)="GotoSave()"
                                    [disabled]="!isSaveEnabled">Save</button>
                                <button class="btn btn-orange ms-1" type="button"
                                    (click)="onCancelClick()">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>

</div>

<div class="modal fade" id="staticBackdrop" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="staticBackdropLabel">
                    {{ 'Vendor Comments' | wordReplace }}
                </h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <textarea class="form-control" style="height: 200px;" [(ngModel)]="vendorComments"></textarea>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btnAS" data-bs-dismiss="modal"
                    (click)="saveVendorComments()">Save</button>
                <button type="button" class="btn btn-orange" data-bs-dismiss="modal">Cancel</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="modalRentalNotes" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="staticBackdropLabel">Rental Notes</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <textarea class="form-control" style="height: 200px;" [(ngModel)]="defaultRentalNotes"></textarea>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btnAS" data-bs-dismiss="modal"
                    (click)="saveRentalNotes()">Save</button>
                <button type="button" class="btn btn-orange" data-bs-dismiss="modal">Cancel</button>
            </div>
        </div>
    </div>
</div>



<div class="modal fade" id="vendorSearchModal" #vendorSearchModal tabindex="-1" aria-labelledby="vendorSearchLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="vendorSearchLabel"> {{ 'Select Vendor' | wordReplace }}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <app-vendor-search [isVendorPopUp]="true" [VendorFilterOption]="VendorFilterOption"
                    (vendorSearchRoute)="onVendorSelected($event)">
                </app-vendor-search>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="viewReceiptModal" tabindex="-1" aria-labelledby="viewReceiptModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl modal-fullSize">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="viewReceiptModalLabel">Preview</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <iframe *ngIf="pdfUrl" [src]="pdfUrl" width="100%" height="500px" frameborder="0"></iframe>
            </div>
            <div class="modal-footer">
                <button class="btn btn-orange" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="modalOpenCash" #modalOpenCash aria-hidden="true" aria-labelledby="modalOpenCashLabel"
    tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content">
            <div class="modal-header">

            </div>
            <div class="modal-body">
                <app-ops-opening-cash-drawer-amount *ngIf="openCashNotSet" [hideOpenCashTopMenu]="hideOpenCashTopMenu"
                    (openCashSaved)="openCashSaved($event)"></app-ops-opening-cash-drawer-amount>
            </div>
            <div class="modal-footer">
                <button class="btn btn-orange" (click)="btnCloseOpenCash()">Cancel</button>
            </div>
        </div>
    </div>
</div>